import { useEffect } from "react";
import { HOTEL } from "./hotel";

/** Minimal per-page metadata (title + description + canonical). */
export function usePageMeta(title, description) {
  useEffect(() => {
    const base = HOTEL.name;
    document.title = title ? `${title} – ${base}` : `${base} – hotellet ved fjorden`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${window.location.origin}${window.location.pathname}`);
  }, [title, description]);
}
